import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IFloorplanNavigatorPresetForms } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath: string = '/web-components-api/floorplan_navigator_preset_forms';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [],
  select: [
    'id',
    'fpnPresetId',
    'availability',
    'type',
    'formKey',
    'link',
    'linkTarget',
    'buttonLabel',
    'modalTitle',
    'modalSubTitle',
    'overriddenByApplicationUrl',
  ],
  alias: 'f',
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [],
  select: [
    'id',
    'fpnPresetId',
    'availability',
    'type',
    'formKey',
    'link',
    'linkTarget',
    'buttonLabel',
    'modalTitle',
    'modalSubTitle',
    'overriddenByApplicationUrl',
  ],
  alias: 'fnpf',
};
const base = new StoreBaseImplementationV2<Partial<IFloorplanNavigatorPresetForms>>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
